export default function utils() {
	
	/*--------------------------------------------------
	DOC READY
	--------------------------------------------------*/
	$(document).ready(function(){
    
    var reposition = function() {
      var modal = $(this),
        dialog = modal.find('.modal-dialog');
      modal.css('display', 'block');

      // Dividing by two centers the modal exactly, but dividing by three 
      // or four works better for larger screens.
      dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
      dialog.css("margin-left", Math.max(0, ($(window).width() - dialog.width()) / 2));
    };
    //$('#protezione').on('show.bs.modal', reposition);
    $('#protezione').modal('show');

    //js attivi
    $('html').removeClass('no-js');
    
		//_blank link esterni
		$('a[href^=http], a.external').click(function() {
			window.open(this.href);
			return false;
		});
    
    //toogle ricerca mobile
    $("#btn-show-form").on('click', function(e){
      $(this).toggleClass('active');
      $("#form-search").slideToggle();
    });
    
    //style select
    if ($('.sumoselect').length > 0) {
      $('.sumoselect').SumoSelect();
    }
    
    //equalheight block
    if ($('.equalheight').length > 0) {
      equalheight('.equalheight');
    }
    
    //navigazione articolo
    if ($('.article-detail').length > 0) {
      //tramite url con anchor
      if(window.location.hash) {
        var hashVal = window.location.hash.split("#")[1];
        $('.anchor-wrapper').addClass('hide');
        $('#'+hashVal).removeClass('hide').addClass('active');
        
        $('a.anchor-link').removeClass('active');
        $('a.anchor-link[href="#'+hashVal+'"]').addClass('active');
      }
      
      //tramite link intro (creati dal template)
      $("a.anchor-link").on('click', function(e){
        //e.preventDefault();
        var hashVal = $(this).attr('href').split("#")[1];
        
        $('.anchor-wrapper').addClass('hide');
        $('#'+hashVal).removeClass('hide').addClass('active');
        
        $("a.anchor-link").removeClass('active');
        $(this).addClass('active');
      });
      
      //tramite bottoni a fine pagine
      $(".nav-article .cta").on('click', function(e){
        //e.preventDefault();
        var stepArt = $(this).parents('.anchor-wrapper.active'),
            hashVal = $(this).attr('href').split("#")[1],
            divAnchor = $('#'+ hashVal);
        if ($(this).hasClass("next")){
          stepArt.removeClass('active').addClass('hide').next('.anchor-wrapper').removeClass('hide').addClass('active');
        } else if ($(this).hasClass("previus")) {
          stepArt.removeClass('active').addClass('hide').prev('.anchor-wrapper').removeClass('hide').addClass('active');
        }
        $('a.anchor-link').removeClass('active');
        $('a.anchor-link[href="#'+hashVal+'"]').addClass('active');
        
        //window.scrollTo(0, 0);
        $('html,body').animate({scrollTop: divAnchor.offset().top},'slow');
      });
    }
    
    //accordion
    if ($('.accordion').length > 0) {
      $('.accordion .accordion__title').on('click', function(e) {
        if(!$(this).parent().hasClass('open')) {
          $(this).parent().addClass('open');
        } else {
          $(this).parent().removeClass('open');
        }
      });
    }
    
	});


	/*--------------------------------------------------
	WIN LOAD
	--------------------------------------------------*/
	$(window).on("load", function (e) {
		
    
    
	});


	/*--------------------------------------------------
	WIN RESIZE
	--------------------------------------------------*/
	$(window).on("resize", function (e) {
		
    let w = $(window).width();
    
    //menu principale
		if(w >= 767) {
			
		} else if(w <= 768) {
			
		}
    
    //equalheight block
    if ($('.equalheight').length > 0) {
      equalheight('.equalheight');
    }
		
	});


	/*--------------------------------------------------
	WIN SCROLL
	--------------------------------------------------*/
	$(window).on('scroll', function(e) {
		
    //equalheight block
    if ($('.equalheight').length > 0) {
      equalheight('.equalheight');
    }
		
	});
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js